import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["usageTracker", "screen"];
import { Alert } from 'foundations-components/transitional/components/Alert';
import { COMPONENT_NAMES } from '../../../../shared/constants';
import { ComponentViewTracker } from '../../../../utils/UsageTracking/ComponentViewTracker';
import { UnifiedMonetizationContent } from '../../private/UnifiedMonetizationContent';
import { jsx as _jsx } from "react/jsx-runtime";
export const MonetizationStatusAlert = _ref => {
  let {
      usageTracker,
      screen
    } = _ref,
    alertProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ComponentViewTracker, {
    screen: screen,
    usageTracker: usageTracker,
    componentName: COMPONENT_NAMES.MONETIZATION_STATUS_ALERT,
    children: /*#__PURE__*/_jsx(Alert, Object.assign({
      "data-test-id": "monetization-status-alert"
    }, alertProps, {
      type: "tip",
      children: /*#__PURE__*/_jsx(UnifiedMonetizationContent, {})
    }))
  });
};